import React from "react";
import { ScrollText, ShieldCheck, ShieldAlert, CheckCircle2 } from "lucide-react";
import { Card } from "@/components/ui/card";
import TermsDialog, { LiabilityDialog } from "@/components/TermsOfUse";
import PrivacyDialog from "@/components/PrivacyPractices";
import { formatDate } from "@/lib/date";

function LegalCard({ icon: Icon, title, description, testId, children, note }) {
  return (
    <Card className="max-w-2xl border-slate-200 p-6 shadow-sm" data-testid={testId}>
      <div className="flex items-start gap-4">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-slate-100 text-slate-600"><Icon className="h-5 w-5" /></span>
        <div className="min-w-0 flex-1">
          <h3 className="font-heading text-lg font-semibold text-slate-800">{title}</h3>
          <p className="mt-1 text-sm text-slate-500">{description}</p>
          {note}
          <div className="mt-4">{children}</div>
        </div>
      </div>
    </Card>
  );
}

// Profile → Legal tab (all roles): one card per policy.
export default function MemberLegalCards({ termsAcceptedAt }) {
  return (
    <div className="space-y-4" data-testid="member-legal-cards">
      <LegalCard icon={ScrollText} title="Terms of Use" testId="legal-terms-card"
        description="The rules for using RallyPointGo, including account responsibilities and acceptable use."
        note={termsAcceptedAt && <p className="mt-2 inline-flex items-center gap-1.5 text-xs font-semibold text-emerald-700" data-testid="legal-terms-accepted"><CheckCircle2 className="h-3.5 w-3.5" /> Accepted {formatDate(termsAcceptedAt)}</p>}>
        <TermsDialog />
      </LegalCard>
      <LegalCard icon={ShieldCheck} title="Privacy & Data Practices" testId="legal-privacy-card"
        description="What information RallyPointGo collects, how it's used and protected, and how long it's kept.">
        <PrivacyDialog />
      </LegalCard>
      <LegalCard icon={ShieldAlert} title="Limitation of Liability" testId="legal-liability-card"
        description="The limits of RallyPointGo's responsibility when you use the app.">
        <LiabilityDialog />
      </LegalCard>
    </div>
  );
}
